// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fullscreen__button{width:40px;height:40px;background-color:rgba(0,0,0,.6);position:absolute;top:8px;right:8px;padding:4px;border-radius:8px;cursor:pointer}.fullscreen__button .fullscreen__button__icon{width:32px;height:32px;opacity:.7}.fullscreen__button .fullscreen__button__icon:hover{opacity:1}@media only screen and (max-width:1367px){.fullscreen__button{display:none}}", ""]);
// Exports
module.exports = exports;
